function startAddMeasurementsModeObserver(element, callback) {
  if (!element) return;
  let debounceTimer;
  // @ts-ignore
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  const observer = new MutationObserver(function (mutations) {
    // eslint-disable-next-line no-restricted-syntax
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        const isAddingMeasurement =
          mutation.target.classList.contains('add-cancel') ||
          mutation.target.querySelector('.icon-checkmark');
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          callback(isAddingMeasurement, observer);
        }, 1000);
      }
    }
  });
  observer.observe(element, {
    attributes: true,
  });
  return () => {
    clearTimeout(debounceTimer);
    observer.disconnect();
  };
}

export { startAddMeasurementsModeObserver };
